import DateFormatter from "@shared/mirage/helpers/DateFormatter";

export class SessionManager {
    public static _sessionTimeoutId: NodeJS.Timeout | undefined;
    public static _sessionModalTimeoutId: NodeJS.Timeout | undefined;
    public static _sessionAttemptIntervalId: NodeJS.Timeout | undefined;
    public static _sessionTimeoutBuffer: number;
    public static _sessionRefreshRequestMaxAttempts = 3;

    public static get lastUserRequestTime(): Date | null {
        const lastTime = localStorage.getItem("lastUserRequestTime");
        return lastTime ? new Date(JSON.parse(lastTime)) : null;
    }

    public static set lastUserRequestTime(time: Date | null) {
        if (time) {
            localStorage.setItem("lastUserRequestTime", JSON.stringify(DateFormatter.formatDateTimeToLocalTimeZoneAgnosticDateTimeString(time)));
        } else {
            localStorage.removeItem("lastUserRequestTime");
        }
        document.dispatchEvent(new StorageEvent("local-storage", { key: "lastUserRequestTime" }));
    }

    public static clearSessionTimeouts() {
        clearTimeout(SessionManager._sessionTimeoutId);
        clearTimeout(SessionManager._sessionModalTimeoutId);
        clearInterval(SessionManager._sessionAttemptIntervalId);
    }

    public static setSessionTimeoutBuffer(bufferMilliseconds: number | undefined) {
        if (bufferMilliseconds) {
            SessionManager._sessionTimeoutBuffer = bufferMilliseconds;
        } else {
            throw Error("Session buffer was not provided");
        }
    }
}
